export class Category {
  private _id: number;
  private _slug: string;
  private _name: string
  private _background: string;
  private _color: string;
  private _order: number;
  private _width: number;
  private _padding: number;
  
  constructor(data: any = null) {
    if (data) {
      this.normalize(data);
    }
  }  

  public normalize(data: any = null) {
    for (const prop in data) {
      if ('description' === prop) {
        let catData = this._readDescription(data[prop]);        
        this.background = catData.background;
        this.color = catData.color;
        this.order = catData.order;
        this.width = catData.width;
        this.padding = catData.padding;
      } else if (! (data[prop] instanceof Object) && ! (data[prop] instanceof Array)) {
        this[prop] = data[prop];      
      }
    }
  }

  private _readDescription(data: string) {
    let catData = { 
      background: '#F69731',
      color: '#EA1D6A',
      order: 100,
      width: 20,
      padding: 20
    }
    if (data) {
      let json = JSON.parse(data);
      if (json.background) { catData.background = json.background; }
      if (json.color) { catData.color = json.color; }
      if (json.order) { catData.order = json.order; }
      if (json.width) { catData.width = json.width; }
      if (json.padding) { catData.padding = json.padding; }
    }
    return catData;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get slug(): string {
    return this._slug;
  }

  set slug(value: string) {
    this._slug = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get background(): string {
    return this._background;
  }

  set background(value: string) {
    this._background = value;
  }

  get color(): string {
    return this._color;
  }

  set color(value: string) {
    this._color = value;
  }

  get order(): number {
    return this._order;
  }

  set order(value: number) {
    this._order = value;
  }

  get width(): number {
    return this._width;
  }

  set width(value: number) {
    this._width = value;
  }

  get padding(): number {
    return this._padding;
  }

  set padding(value: number) {
    this._padding = value;
  }
}
